import { render, staticRenderFns } from "./FloodSensitivityBuilding.vue?vue&type=template&id=1adcec31&"
import script from "./FloodSensitivityBuilding.vue?vue&type=script&lang=ts&"
export * from "./FloodSensitivityBuilding.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports